import React from "react";
import "./OrderAndInvoicePage.css";
import ApplicationHeader from "../components/Headers/ApplicationHeader/ApplicationHeader";
import UserOrder from "../components/OrderAndInvoice/Order";
import UserInvoice from "../components/OrderAndInvoice/Invoice";
import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import sdk from "../sdk/sdk";
import FSLoader from "../components/Loaders/FSLoader";
import { useAuth } from "../components/Auth/useAuth";
import { useVrpRedirect } from "../components/Auth/useVrpRedirect";

function OrderAndInvoicePage() {
  const [isInvoiceVisible, setisInvoiceVisible] = useState(false);
  const [isOrderVisible, setisOrderVisible] = useState(false);
  const [loading, isLoading] = useState(true);

  const [orderInvoiceData, setOrderInvoiceData] = useState(null);
  const [pdfData, setPdfData] = useState({});

  const [{ user }] = useAuth();
  useVrpRedirect();

  useEffect(() => {
    isLoading(true);
    const handleResize = () => {
      setisOrderVisible(true);
      setisInvoiceVisible(window.innerWidth > 768);
    };
    async function fetchData() {
      try {
        const data = await sdk.commande.history.get(user?.client_profile?.id);
        setOrderInvoiceData(data.payload);
        setisOrderVisible(true);
        handleResize();
        isLoading(false);
      } catch (error) {
        console.error("something went wrong", user?.client_profile?.id, error);
      }
    }
    fetchData();

    window.addEventListener("resize", handleResize);
  }, []);

  const toggleOrder = () => {
    setisInvoiceVisible(!isInvoiceVisible);
    setisOrderVisible(false);
  };

  const toggleLeftDiv = () => {
    setisInvoiceVisible(false);
    setisOrderVisible(true);
  };

  function renderOrdersAndInvoices() {
    if (!Array.isArray(orderInvoiceData) || orderInvoiceData?.length === 0) {
      return (
        <React.Fragment>
          <div className="text-center no-result">
            <span>
              Votre compte ne contient encore aucune commande ni facture.
              Veuillez vérifier ultérieurement ou passer commande.
            </span>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <UserOrder
          isOrderVisible={isOrderVisible}
          data={orderInvoiceData}
          toggleOrder={toggleOrder}
          onPdfClick={(data) => setPdfData(data)}
        />
        <UserInvoice
          isInvoiceVisible={isInvoiceVisible}
          toggleLeftDiv={toggleLeftDiv}
          pdfData={pdfData}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ApplicationHeader />
      {loading ? (
        <FSLoader />
      ) : (
        <Container fluid>
          <div className="order-invoice-page">{renderOrdersAndInvoices()}</div>
        </Container>
      )}
    </React.Fragment>
  );
}

export default OrderAndInvoicePage;
